module.exports = __webpack_public_path__ + "assets/img/logo.1d945c40.png";